<template>
  <div class="yxtbiz-rank-setter_style">
    <yxt-form
      ref="rankForm"
      :model="rankForm"
      :rules="rules"
      :enableDetectFieldsChange="isInitialFinished"
      label-position="top"
    >
      <yxt-form-item
        :label="$t('pc_biz_rank_default_rank_period').d('默认排行周期')"
        prop="defaultDateType"
        class="yxtbiz-rank-setter_style_select_item"
      >
        <yxt-select
          v-model="rankForm.defaultDateType"
          class="mt8 yxtbiz-rank-setter_style_select"
          size="small"
          :placeholder="$t('pc_biz_lbl_selecttip').d('请选择')"
        >
          <yxt-option
            v-for="item in dateList"
            :label="$t(item.label).d(item.text)"
            :value="item.type"
            :key="item.type"
          ></yxt-option>
        </yxt-select>
      </yxt-form-item>
      <yxt-form-item
        :label="$t('pc_biz_rank_show_how_many_top').d('展示前多少名')"
        prop="rankTop"
        class="yxtbiz-rank-setter_style_select_item"
      >
        <yxt-input-number
          class="mt8 yxtbiz-rank-setter_style_input_number"
          size="small"
          v-model="rankForm.rankTop"
          :precision="0"
          :min="3"
          :max="200"
          @blur="onRankTopBlur"
        ></yxt-input-number>
        <span class="ml12 text-8c standard-size-12">{{
          $t('pc_biz_rank_show_tip').d('支持展示3-200名')
        }}</span>
      </yxt-form-item>
      <yxt-form-item
        :label="$t('pc_biz_rank_show_rule').d('相同数值排名')"
        prop="rankType"
        class="mb15"
      >
        <yxt-radio-group v-model="rankForm.rankType">
          <yxt-radio
            v-for="item in typeList"
            :key="item.type"
            :label="item.type"
          >
            {{ $t(item.label) }}
            <yxt-tooltip effect="light" placement="top" max-height="130">
              <div slot="content" class="yxtbiz-rank-setter_style_rankType_img">
                <yxt-image
                  width="92px"
                  height="112px"
                  :src="
                    `${$staticBaseUrl}ufd/55a3e0/ssp/pc/img/` +
                    item.icon +
                    '.png'
                  "
                />
              </div>
              <span class="yxtbiz-rank-setter_style_question-icon" style="cursor: auto">
                <yxt-svg
                  class="color-gray-6 hover-primary-6"
                  width="16px"
                  height="16px"
                  icon-class="icons/question-cirlce-o"
                />
              </span>
            </yxt-tooltip>
          </yxt-radio>
        </yxt-radio-group>
      </yxt-form-item>
      <yxt-form-item
        :label="$t('pc_biz_rank_show_content').d('展示内容')"
        prop="rankContent"
        class="yxtbiz-rank-setter_style_showContent mb15"
      >
        <yxt-checkbox-group
          v-model="rankForm.rankContent"
          @change="onContentChange"
        >
          <yxt-checkbox
            v-for="item in contentList"
            :key="item.type"
            :label="item.type"
            :disabled="!item.select"
          >
            <span>{{ $t(item.label).d(item.text) }}</span>
          </yxt-checkbox>
        </yxt-checkbox-group>
      </yxt-form-item>
      <yxt-form-item
        :label="$t('pc_biz_rank_show_style').d('展示样式')"
        prop="rankStyle"
      >
        <yxt-radio-group
          v-model="rankForm.rankStyle"
          class="mt8 yxtbiz-rank-setter_style_rankStyle flex"
        >
          <div
            v-for="item in styleList"
            :key="item.type"
            class="mr24 yxtbiz-rank-setter_style_img_box"
          >
            <div class="yxtbiz-rank-setter_style_img">
              <yxt-image
                width="56px"
                height="83px"
                :src="
                  `${$staticBaseUrl}ufd/55a3e0/ssp/pc/img/` +
                  item.icon +
                  '.png'
                "
              />
            </div>
              <yxt-tooltip
                :disabled="!(item.type === 2 && styleDisabled)"
                :content="
                  $t('pc_biz_rank_style_tip').d(
                    '必须选择部门图标来适配样式'
                  )
                "
              >
              <yxt-radio
                :label="item.type"
                :disabled="item.type === 2 && styleDisabled"
              >
                {{ $t(item.label).d(item.text) }}
              </yxt-radio>
             </yxt-tooltip>
          </div>
        </yxt-radio-group>
      </yxt-form-item>
    </yxt-form>
  </div>
</template>
<script>
import { typeList, styleList } from './config';

export default {
  data() {
    return {
      typeList, // 相同数值排名
      styleList, // 展示样式
      rankForm: {
        defaultDateType: 1, // 默认排行周期
        rankTop: 50, // 展示前多少名
        rankType: 2, // 1：并列排名，2：顺序排名
        rankContent: [], // 展示内容
        rankStyle: 1 // 展示样式 1：列表式，2：横排式
      },
      rules: {
        defaultDateType: {
          required: true,
          message: this.$t('pc_biz_lbl_selecttip').d('请选择')
        },
        rankTop: {
          required: true
        },
        rankType: {
          required: true,
          message: this.$t('pc_biz_lbl_selecttip').d('请选择')
        },
        rankContent: {
          required: true,
          message: this.$t('pc_biz_lbl_selecttip').d('请选择')
        },
        rankStyle: {
          required: true,
          message: this.$t('pc_biz_lbl_selecttip').d('请选择')
        }
      },
      isInitialFinished: false
    };
  },
  props: {
    // 排行周期
    dateList: {
      type: Array,
      default: () => []
    },
    // 默认排行周期
    defaultDate: {
      type: Number,
      default: 1
    },
    // 展示内容
    contentList: {
      type: Array,
      default: () => []
    },
    // 默认选中的内容
    content: {
      type: String,
      default: ''
    }
  },
  computed: {
    // 当参与对象是 部门人均/部门总计，展示内容未选择 部门图标时，横排式禁止选择
    styleDisabled() {
      return (
        this.contentList.find(c => c.type === 'deptImg') &&
        !this.rankForm.rankContent.includes('deptImg')
      );
    }
  },
  watch: {
    defaultDate: {
      handler(v) {
        this.rankForm.defaultDateType = v;
      },
      immediate: true
    },
    content: {
      handler(v) {
        this.rankForm.rankContent = v.split(',');
        this.onContentChange();
      },
      immediate: true
    }
  },
  methods: {
    // 初始化数据
    init(data) {
      Object.keys(this.rankForm).forEach(k => {
        this.rankForm[k] = data[k];
      });
      this.$nextTick(() => {
        this.isInitialFinished = true;
      });
    },
    // 展示前多少名 删除后恢复成默认50
    onRankTopBlur() {
      !this.rankForm.rankTop && (this.rankForm.rankTop = 50);
    },
    // 展示内容 更改时
    onContentChange() {
      // 当参与对象是 部门人均/部门总计，展示内容未选择 部门图标时，横排式禁止选择
      if (this.styleDisabled && this.rankForm.rankStyle === 2) {
        this.rankForm.rankStyle = 1;
      }
    }
  }
};
</script>
